import { StatePanel, type StatePanelProps } from './state-panel';

export const WarningPanel = (props: Omit<StatePanelProps, 'tone'>) => (
  <StatePanel tone='warning' {...props} />
);
